import React from 'react';

// Grouped status checklist used inside the Status filter pill popover.
// `selected` is the list of currently-selected status values.
const StatusFilterPanel = ({ groups, allValues, selected, onChange }) => {
  const toggle = (status) => {
    if (selected.includes(status)) {
      onChange(selected.filter((s) => s !== status));
    } else {
      onChange([...selected, status]);
    }
  };

  return (
    <div className="w-64">
      <div className="flex items-center justify-center gap-6 border-b border-gray-200 px-3 py-2">
        <button
          onClick={() => onChange([...allValues])}
          className="text-[13px] font-medium text-blue-600 hover:underline"
        >
          Select All
        </button>
        <button
          onClick={() => onChange([])}
          className="text-[13px] font-medium text-blue-600 hover:underline"
        >
          Select None
        </button>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {groups.map((group) => (
          <div key={group.label}>
            <div className="bg-gray-50 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-gray-500">
              {group.label}
            </div>
            {group.statuses.map((status) => (
              <div
                key={status}
                className="group flex items-center gap-2.5 px-3 py-1.5 hover:bg-gray-50"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(status)}
                  onChange={() => toggle(status)}
                  className="h-3.5 w-3.5 accent-gray-900 rounded"
                />
                <span className="flex-1 truncate text-[13px] text-gray-800">{status}</span>
                <button
                  onClick={() => onChange([status])}
                  className="text-[12px] text-gray-400 opacity-0 transition-opacity hover:text-gray-800 hover:underline group-hover:opacity-100"
                >
                  only
                </button>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusFilterPanel;
